import React from "react";
import DateRangePicker from "react-bootstrap-daterangepicker";
import "bootstrap-daterangepicker/daterangepicker.css";
import moment from "moment";
import { setQueryParams } from "../../helpers/misc";

const DateRange = props => {
  function updateDateRangeData(event, picker) {
    const startDate = picker.startDate.format("YYYY-MM-DD");
    const endDate = picker.endDate.format("YYYY-MM-DD");
    const component = {
      startDate: startDate,
      endDate: endDate,
      label: startDate + " to " + endDate,
      type: props.type,
      name: props.name
    };
    props.updateState(component);
    // console.log(component);
    setQueryParams({
      [`${props.name}`]: `${startDate}to${endDate}`
    });
    props.ChangeDashboardData();
  }

  const monthInitGreaterDate = moment("2019-10-21").isBefore(
    moment().startOf("month")
  )
    ? moment().startOf("month")
    : moment("2019-10-21");
  const last30InitGreaterDate = moment("2019-10-21").isBefore(
    moment().subtract(30, "days")
  )
    ? moment().subtract(30, "days")
    : moment("2019-10-21");

  const ranges = {
    Yesterday: [moment().subtract(1, "days"), moment().subtract(1, "days")],
    "Last 7 Days": [moment().subtract(7, "days"), moment().subtract(1, "days")],
    "Last 30 Days": [last30InitGreaterDate, moment().subtract(1, "days")],
    "This Month": [monthInitGreaterDate, moment().subtract(1, "days")]
  };

  return (
    <DateRangePicker
      onApply={updateDateRangeData}
      startDate={moment(props.startDate)}
      endDate={moment(props.endDate)}
      minDate={moment("2019-10-21")}
      maxDate={moment().subtract(1, "days")}
      ranges={ranges}
      containerStyles={{ display: "block" }}
      opens="left"
    >
      <button className="date-btn semi-bold">
        <span className="vertical-middle">{props.label}</span>
        <i className="icon icon-ic-calendar vertical-middle" />
      </button>
    </DateRangePicker>
  );
};

export default DateRange;
